jQuery( '.burgerBun' ).click( function() {
  jQuery( '.burgerBun' ).toggleClass( "open" );
  jQuery( '.mobile-menu-parent' ).toggleClass( "open" );
  jQuery('.burgerBox').toggleClass('open');
} );



jQuery( '.menu-mobile-menu-container a' ).click( function() {
  jQuery( '.burgerBun' ).removeClass( "open" );
  // jQuery('.menu-mobile-menu-container').removeClass("open");
  jQuery( '.mobile-menu-parent' ).toggleClass( "open" );
} );


const header = document.getElementById( 'site-header' );

updateHeaderState();
window.addEventListener( 'scroll', updateHeaderState, { passive: true } );

function updateHeaderState( e ) {
  header.querySelector( '.menu-primary-menu-left-container' ).removeAttribute( 'style' );



  if ( window.scrollY > 5 ) {
    header.classList.add( 'scroll' );

    if ( e?.type === 'scroll' ) {
      header.classList.remove( 'right' );
      header.classList.add( 'left' );
    }
  } else {
    header.classList.remove( 'scroll' );

    if ( e?.type === 'scroll' ) {
      header.classList.remove( 'left' );
      header.classList.add( 'right' );
    }
  }
}



jQuery( '.nav-hamburger' ).click( function() {
  jQuery( '.burger-menu' ).toggle( function() {
    jQuery( this ).animate( { 'right': 0 }, 100 );

    jQuery( '.burger-menu .list-container' ).fadeTo( "slow", 1 );
  } );
} );



jQuery( '.close-burger-menu' ).click( function() {
  jQuery( '.burger-menu' ).toggle( function() {
    jQuery( this ).animate( { 'left': 0 }, 100 );

    jQuery( '.burger-menu .list-container' ).fadeTo( "slow", 0 );
  } );
} );

jQuery('.burger-menu .list-container').fadeTo("slow", 0);

document.addEventListener('DOMContentLoaded', function() {
  const menuItems = document.querySelectorAll('.menu-mobile-services-menu-container .menu-item-has-children');

  menuItems.forEach(item => {
      const link = item.querySelector('a');
      if (link) {
          link.addEventListener('click', function(event) {
              
              // Check if the click is on the ::after pseudo-element
              const afterElement = window.getComputedStyle(this, '::after');
              const afterElementWidth = parseFloat(afterElement.width);
              const afterElementHeight = parseFloat(afterElement.height);
              const afterElementRight = parseFloat(afterElement.right);
              const afterElementTop = parseFloat(afterElement.top);

              const rect = this.getBoundingClientRect();
              const clickX = event.clientX - rect.left;
              const clickY = event.clientY - rect.top;

              if (clickX >= rect.width - afterElementRight - afterElementWidth &&
                  clickX <= rect.width - afterElementRight &&
                  clickY >= afterElementTop &&
                  clickY <= afterElementTop + afterElementHeight) {
                  event.preventDefault();
                  event.stopPropagation(); // Prevent the click event from bubbling up
                  item.classList.toggle('show-sub-menu');
              }
          });
      }
  });
});